import * as React from "react";

export interface ICustomerDetailsContext {
  contentRef: React.RefObject<HTMLDivElement>;
}
/**
 * @deprecated
 */
// @ts-expect-error TS(2322): Type 'null' is not assignable to type 'RefObject<H... Remove this comment to see the full error message
export const CustomerDetailsContext = React.createContext<ICustomerDetailsContext>({ contentRef: null });
